import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import MfMinisiteHomeView from "../components/mfminisite/views/MfMinisiteHomeView.vue";
import MathLevelView from "../views/maths/MathLevelView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: MfMinisiteHomeView
  },
  {
    path: "/maths/level/:levelId?",
    name: "MathLevel",
    component: MathLevelView,
    props: { isMathsframe: true },
  }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

export default router;